import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { X } from 'lucide-react';
import { cn } from '@ci-ville/ui';
export function Modal({ open, onClose, title, description, children, footer, size = 'md' }) {
    React.useEffect(() => {
        if (!open)
            return;
        const handler = (e) => {
            if (e.key === 'Escape')
                onClose();
        };
        document.addEventListener('keydown', handler);
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('keydown', handler);
            document.body.style.overflow = '';
        };
    }, [open, onClose]);
    if (!open)
        return null;
    const sizeClass = { sm: 'max-w-sm', md: 'max-w-md', lg: 'max-w-2xl' }[size];
    return (_jsx("div", { className: "fixed inset-0 z-[2000] flex items-center justify-center bg-black/50 p-4 backdrop-blur-sm", onClick: onClose, role: "dialog", "aria-modal": "true", "aria-labelledby": "modal-title", children: _jsxs("div", { className: cn('w-full overflow-hidden rounded-lg bg-card shadow-2xl', sizeClass), onClick: (e) => e.stopPropagation(), children: [_jsxs("div", { className: "flex items-start justify-between border-b border-border p-4", children: [_jsxs("div", { children: [_jsx("h2", { id: "modal-title", className: "text-lg font-semibold", children: title }), description && _jsx("p", { className: "mt-1 text-sm text-muted-foreground", children: description })] }), _jsx("button", { onClick: onClose, className: "rounded-md p-1 text-muted-foreground hover:bg-muted hover:text-foreground", "aria-label": "Fermer", children: _jsx(X, { className: "size-4" }) })] }), _jsx("div", { className: "max-h-[70vh] overflow-y-auto p-4", children: children }), footer && _jsx("div", { className: "flex justify-end gap-2 border-t border-border bg-muted/30 p-3", children: footer })] }) }));
}
//# sourceMappingURL=Modal.js.map